/* eslint-disable max-len */

const MILITARY_STORAGE_DATA = [
	{
		heading: "Military Storage",
		description:
			"Many active military members move frequently due to base assignments and tours of duty, which can make it difficult to hang on to many belongings. Those who want to serve their country and also keep the belongings they already have can turn to self storage as a resource."
	},
	{
		subHeadings: [
			{
				title: "How self storage can help military members",
				desc: "Because military members move so frequently, it can be troublesome to own a large amount of furniture or other valuables. Some service members choose to sell some of their items to make moving easier, but for those who want to hold on to valuable possessions, there's another choice. Self storage allows military members to keep all of their favorite belongings, even when they're halfway across the world. Here are a few scenarios where self storage can be a great asset for military members."
			}
		],
		points: [
			{
				title: "Help during transitions with frequent moves: ",
				desc: "Military members can use self storage as a transition aid when moving from one base to another. If there's a short lapse in housing, you will still have room for all of your things."
			},
			{
				title: "Save money during high cost of living assignments: ",
				desc: "Those who are on assignments where housing is more expensive can use self storage to downsize while sticking to a budget."
			},
			{
				title: "Auto storage during deployment: ",
				desc: "When military members are deployed, they have to leave all of their things behind. The most difficult item to store is often a car, so many service members use auto storage while they are overseas."
			}
		]
	},
	{
		subHeadings: [
			{
				title: "Military Discounts",
				descLink: {
					contentBefore:
						"Many facilities on Storage.com offer discounts for our nation's troops as a way to show appreciation for their selfless service. If you are active military looking to rent self storage, call us at  ",
					linkText: "(833) 448-1067",
					phone: {
						// temp until we implement sparephone
						formattedNumber: "833-448-1067",
						number: "8334481067"
					},
					contentAfter:
						", and we'll help identify which facilities offer military discounts in your area. Most storage facilities will ask for military identification to verify your military involvement upon arrival at the facility."
				}
			}
		]
	},
	{
		subHeadings: [
			{
				title: "Factors to consider",
				desc: "There are other factors to consider when looking for storage that go beyond price and location. If you want to have the best storage experience possible, there are ways you can make it more efficient for your needs."
			}
		],
		points: [
			{
				desc: "If you're on assignment or are being deployed, you can store your items in a storage unit that's located in the city you wish to return to. If your military career is coming to an end soon, place your valuables in a storage unit near your intended future home so it's all there waiting for you when you return."
			},
			{
				desc: "Depending on where your storage unit is located, you may want to consider climate-controlled storage. If you're going to be storing things for an extended period of time, fluctuating temperatures and humidity can easily damage your valuables. Protect them with a climate-controlled storage unit."
			},
			{
				desc: "Finding a storage facility with quality security features like gated access, video surveillance, and alarmed units is a great idea, especially if you plan on storing valuable belongings for any extended length of time."
			}
		]
	}
];

export { MILITARY_STORAGE_DATA };
